import { render, staticRenderFns } from "./CarouselMultipleSlidesPerView.vue?vue&type=template&id=317eae0a&"
import script from "./CarouselMultipleSlidesPerView.vue?vue&type=script&lang=js&"
export * from "./CarouselMultipleSlidesPerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports